import * as React from "react";
import {authorize} from "@athena-portal/components";
import {PluginTemplates} from "../../utils/PluginTemplates";
import FalconHeader from "../../components/navigation/FalconHeader";
import FalconFooter from "../../components/navigation/FalconFooter";
import {FalconNavigatorHeader} from "@falcon/services";

@authorize
export class CoronaSupportPage extends React.Component {

    private pluginTemplates = new PluginTemplates();

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Corona");
    }

    public render() {
        return (
            <React.Fragment>

                <FalconHeader/>

                <div className="plugin">
                    <FalconNavigatorHeader
                        back="/dashboard"
                        title="Coronavirus and your car insurance..."
                    />

                    <div className="inner-container">
                        <div className="claims plugin-panel inner-content">
                            <div className="muli-bold-16">Wondering how coronavirus might affect your car insurance with us?</div>
                            <div className="muli-light-16">Here's what you need to know...</div>

                            <div className="muli-light-16 mt-4">In these uncertain times, the knock on effect is impacting multiple areas of our everyday lives, one of which is the use of our cars. Whether you’re using yours more often in order to avoid public transport, or you now need to use your car for work, we support you wholly and will do everything we can to make sure that your Allianz car insurance subscription is one thing you can be certain about.</div>

                            <div className="muli-light-16 mt-4">Please see our FAQ’s below where we may cover any questions you have. In the meantime, stay safe and please bear with us while we do all we can to support our customers and employees</div>

                            <div className="muli-bold-16 mt-4">Will I still be able to make a claim?</div>
                            <div className="muli-light-16">Yes, we are honouring our existing customers across all of our products, so you will be able to make a claim or renew as normal. Bear in mind that our call centres are really busy at the moment, so please use our online services wherever you can.</div>

                            <div className="muli-bold-16 mt-4">I now need to use my car for work; will my car insurance be affected?</div>
                            <div className="muli-light-16">If you now need to use your car for work or are choosing to drive to work in order to avoid public transport due to social distancing, business use (class 1) will be the minimum class of use for Allianz subscription car insurance with immediate effect and until further notice. There will be no charge for this increase in cover and it will be honoured should you need to claim.</div>

                            <div className="muli-bold-16 mt-4">Can I use my car to help vulnerable people in my community with everyday tasks?</div>
                            <div className="muli-light-16">Yes, you’re covered to use your car in this way. Any voluntary work is included as standard such as collecting shopping or prescriptions. Thank you for being wonderful.</div>

                            <div className="muli-bold-16 mt-4">I’m a key worker; can I use my car for work due to the impact of COVID-19?</div>
                            <div className="muli-light-16">Yes, business use (class 1) will be the minimum class of use for Allianz subscription car insurance with immediate effect and until further notice. There will be no charge for this increase in cover and it will be honoured should you need to claim.</div>

                            <div className="muli-bold-16 mt-4">How will coronavirus (COVID-19) affect my MOT?</div>
                            <div className="muli-light-16">Mandatory MOT testing was <a className="d-inline" href="https://www.gov.uk/government/news/mandatory-mot-testing-to-be-reintroduced-from-1-august" target="_blank">reintroduced</a> on 1 August 2020 as lockdown restrictions begin to ease. Due to the coronavirus outbreak, drivers were granted a 6 month exemption from MOT testing in March to help slow the spread of the virus. However, as restrictions are eased, all drivers whose car, motorcycle or van is due for an MOT test from 1 August will need to get a test certificate to continue driving their vehicle.It’s your responsibility to ensure that your vehicle is roadworthy and not driven in an unsafe condition, and we may not be able to cover you if you’re in an accident due to poor maintenance of the car. For more information on this, you can keep up to date at <a className="d-inline" href="https://www.gov.uk/" target="_blank">GOV.UK</a></div>

                            <div className="muli-bold-16 mt-4">Thank you to all NHS staff and key workers across the board for doing all you’re doing at this time, we appreciate you.</div>
                        </div>
                    </div>

                    {this.pluginTemplates.renderBackLink("Back", false, "/dashboard")}
                </div>
                <FalconFooter/>

            </React.Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/CoronaSupportPage.tsx